import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons';
import LikeInfoPopup from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup';
import { likeSectionPopupToggle } from 'mk2/apps/blogs/containers/LikeSection/LikeSection.actions';
import reducer, { LikeSectionState } from 'mk2/apps/blogs/containers/LikeSection/LikeSection.reducers';
import { getLikeSectionState } from 'mk2/apps/blogs/containers/LikeSection/LikeSection.selectors';
import Btn, { BtnLayout, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import Modal from 'mk2/components/Modal';
import registerInStore from 'mk2/decorators/registerInStore';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import styles from './LikeSection.mscss';

interface OwnProps {
    entityType: string;
    entityId: number;
    linkAccessKey?: string;  // pouziva sa v blogoch na pristup k privatnym postom bez loginu

    likesCount: number;
}

interface StateProps {
    showModal: boolean;
}

interface DispatchProps {
    onPopupToggle(entityType: string, entityId: number);
}

type Props = OwnProps & StateProps & DispatchProps;

class LikeSection extends React.Component<Props> {

    public render() {
        const { entityType, entityId, linkAccessKey, likesCount, showModal } = this.props;

        if (likesCount === 0) {
            return null;
        }
        return (
            <React.Fragment>
                <Btn
                    layout={BtnLayout.LabelIcon}
                    type={BtnType.GreyText}
                    label={likesCount}
                    icon={faThumbsUp}
                    sidePadding={BtnSidePadding.None}
                    onClick={this.handleOnPopupToggle}
                    classNames={{
                        icon: styles.LikeSection__button,
                    }}
                />

                <Modal key="modal" show={showModal} onHide={this.handleOnPopupToggle}>
                    <LikeInfoPopup
                        entityType={entityType}
                        entityId={entityId}
                        linkAccessKey={linkAccessKey}
                        onHide={this.handleOnPopupToggle}
                    />
                </Modal>
            </React.Fragment>
        );
    }

    private handleOnPopupToggle = () => {
        const { entityType, entityId, onPopupToggle } = this.props;
        onPopupToggle(entityType, entityId);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { entityType, entityId } = ownProps;
    const lsState: LikeSectionState = getLikeSectionState(state, entityType, entityId);

    return {
        showModal: lsState.showModal,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onPopupToggle: likeSectionPopupToggle,
};

export default registerInStore<OwnProps>((store) => {
    store.injectReducer('containers.blogs.shared.likeSections', reducer);
})(connect(mapStateToProps, mapDispatchToProps)(LikeSection));
